const browserButtons = {
  mounted() {
    window.onpopstate = () => {
      this.restart().then((res) => {
        this.$router.push({ path: `/${res.page}` });
      });
    };
  },
};

export default browserButtons;
